import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translation files
import enTranslations from './locales/en/translation.json';
import esTranslations from './locales/es/translation.json';
import frTranslations from './locales/fr/translation.json';
import deTranslations from './locales/de/translation.json';
import itTranslations from './locales/it/translation.json';
import jaTranslations from './locales/ja/translation.json';
import nlTranslations from './locales/nl/translation.json';
import ptTranslations from './locales/pt/translation.json';
import zhCNTranslations from './locales/zh-CN/translation.json';

const resources = {
  en: { translation: enTranslations },
  es: { translation: esTranslations },
  fr: { translation: frTranslations },
  de: { translation: deTranslations },
  it: { translation: itTranslations },
  ja: { translation: jaTranslations },
  nl: { translation: nlTranslations },
  pt: { translation: ptTranslations },
  'zh-CN': { translation: zhCNTranslations },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en', // default language
    fallbackLng: 'en',
    
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    
    react: {
      useSuspense: false,
    },
  });

export default i18n;